import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import useLearnerAuth from "./useLearnerAuth"
import LearnerAuthBootScreen from "./LearnerAuthBootScreen"
import { LEARNER_LOGIN_PATH } from "./constants"

interface RequireLearnerAuthProps {
  children: React.ReactNode
}

const RequireLearnerAuth = ({ children }: RequireLearnerAuthProps) => {
  const { isBooting, isAuthenticated } = useLearnerAuth()
  const location = useLocation()

  if (isBooting) {
    return <LearnerAuthBootScreen />
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`)
    return <Navigate to={`${LEARNER_LOGIN_PATH}?next=${next}`} replace />
  }

  return <>{children}</>
}

export default RequireLearnerAuth
